module.exports = __webpack_public_path__ + "static/media/Group 1072 (2).715f1b01.svg";